/**
 * Created by lihanying on 2017/6/26.
 */
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as actions from './action'
import CommodityList from './component/commodityList'
import { Spin } from 'antd'
import ClubStorage from '../ClubStorage'

class ClubCommodity extends React.Component {
  static defaultProps = {
    clubCommodity: {},
    clubCommodityOut: {},
    commodityType: [],
    qiniuToken: {},
    imageUrl: {
      url: '',
      name: '',
    },
    inStorage: {
      info: {},
      list: [],
    },
    commodityTotal: {
      firmList: [],
    },
  }
  state = {
    loading: true,
  }

  componentDidMount() {
    this.props.fetchClubCommodity({ p: 1 }).then((res) => {})
    this.props.fetchCommodityType().then((res) => {
      this.setState({ loading: false })
    })
  }

  render() {
    return (
      <div>
        {this.state.loading ? (
          <Spin
            tip="正在加载..."
            className="level-loading"
            style={{ textAlign: 'center' }}
          />
        ) : (
          <div>
            <CommodityList
              {...this.props}
              fetchCommodityType={this.props.fetchCommodityType}
              fetchQiniuToken={this.props.fetchQiniuToken}
              fetchQiniu={this.props.fetchQiniu}
              getImageUrl={this.props.getImageUrl}
              fetchSettingCommodity={this.props.fetchSettingCommodity}
              fetchSetCommodity={this.props.fetchSetCommodity}
              fetchGetProcurement={this.props.fetchGetProcurement}
              fetchCommodityTotal={this.props.fetchCommodityTotal}
              fetchCommodityAddTotal={this.props.fetchCommodityAddTotal}
              fetchRemoveFreeze={this.props.fetchRemoveFreeze}
            />
            <ClubStorage />
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    clubCommodity: state.getClubCommodity.clubCommodity,
    clubCommodityOut: state.getClubCommodity.clubCommodityOut,
    commodityType: state.getClubCommodityType.clubCommodityType,
    qiniuToken: state.getClubCommodity.qiniuToken,
    imageUrl: state.getClubCommodity.imageUrl,
    inStorage: state.getClubCommodity.inStorage,
    commodityTotal: state.getClubCommodity.commodityTotal,
  }
}
export default withRouter(connect(mapStateToProps, actions)(ClubCommodity))



// WEBPACK FOOTER //
// ./src/containers/ClubCommodity/index.js